import { Button, Row, Typography, useModal } from "@commonlibs";
import CreateAdminModal from "ui/admins/components/CreateAdminModal/CreateAdminModal";
import ModifyMovementsModal from "ui/admins/components/ModifyMovementsModal/ModifyMovementsModal";
import useTranslate from "ui/locale/hooks/useTranslate";

export default function RightToolbar() {
    const translate = useTranslate();
    const { showModal } = useModal();

    return (
        <Row gap={10}>
            <Button variant="secondary" onClick={() => showModal(ModifyMovementsModal)}>
                <Typography variant="body2Strong">{translate("movementModifications")}</Typography>
            </Button>
            <Button onClick={() => showModal(CreateAdminModal)}>
                <Typography variant="body2Strong">{translate("createAdmin")}</Typography>
            </Button>
        </Row>
    );
}
